module.exports = __webpack_public_path__ + "static/media/two-kids-big-hats.c6834c87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/two-kids-big-hats.jpg
// module id = 833
// module chunks = 0